module.exports = __webpack_public_path__ + "img/08_Gipser_Trockenbauer_Foto_2020.c2e0aa5c.jpg";